import axios from 'axios';
import EnvService from '@/plugins/EnvService';

export default class WebService {
  constructor(ctx) {
    this.ctx = ctx
    axios.defaults.validateStatus = () => {
      return true
    };
    axios.defaults.timeout = 1000 * 60 * 1 // 1min;
  }

  //user
  async login(restUrl, username, password) {
    return await axios.get(EnvService.serviceURLPL+restUrl, {
      auth: {
        username: username,
        password: password
      }
    })
  }

  async getUser(restUrl, username, sapClientId) {
    return await axios.get(EnvService.serviceURLPL+restUrl+"/"+username+"/"+sapClientId, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getUsers(restUrl) {
    return await axios.get(EnvService.serviceURLPL+restUrl, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async deleteUser(restUrl, key) {
    return await axios.delete(EnvService.serviceURLPL+restUrl+"/"+key, {
      data: key,
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async updateUser(restUrl, item, key) {
    return await axios.put(EnvService.serviceURLPL+restUrl+"/"+key, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async insertUser(restUrl, item) {
    return await axios.post(EnvService.serviceURLPL+restUrl, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getUserNoAuth(restUrl, username, sapClientId) {
    return await axios.get(EnvService.serviceURLPL+restUrl+"/"+username+"/"+sapClientId)
  }

  async sendEMail(restUrl, mailEntity) {
    return await axios.post(EnvService.serviceURLPL+restUrl, mailEntity, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async issueNewPassword(restUrl, mailEntity) {
    return await axios.post(EnvService.serviceURLPL+restUrl, mailEntity)
  }

  async setNewPassword(restUrl, item) {
    return await axios.post(EnvService.serviceURLPL+restUrl, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getCustomer(restUrl, kdnnr) {
    return await axios.get(EnvService.serviceURLPL+restUrl+"/"+kdnnr, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  //PL
  async getComboData(restUrl,plParameter) {
    return await axios.post(EnvService.serviceURLPL+restUrl, plParameter, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getPLListByArtikel(restUrl,artnr,sprcd,kdnnr,sapClientId) {
    return await axios.get(EnvService.serviceURLPL+restUrl+"/"+artnr+"/"+sprcd+"/"+kdnnr+"/"+sapClientId, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getPLListByParameter(restUrl,plParameter) {
    return await axios.post(EnvService.serviceURLPL+restUrl, plParameter, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getPLArtikelData(restUrl,artnr,sprcd,sapClientId) {
    return await axios.get(EnvService.serviceURLPL+restUrl+"/"+artnr+"/"+sprcd+"/"+sapClientId, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getProductImage(restUrl) {
    return await axios.get(EnvService.serviceURLPL+restUrl, {responseType: "blob"})
  }

  async getSdbPdf(restUrl, item) {
    return await axios.post(EnvService.serviceURLPL+restUrl, item, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    })    
  }

  //data targets
  async getDataTarget(restUrl,id) {
    return await axios.get(EnvService.serviceURLPL+restUrl+"/"+id+"/"+EnvService.dataTargetEnvironment, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getDataTargets(restUrl) {
    return await axios.get(EnvService.serviceURLPL+restUrl+"/"+EnvService.dataTargetEnvironment, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getODataTargets(restUrl) {
    return await axios.get(EnvService.serviceURLPL+restUrl, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async deleteDataTarget(restUrl, key) {
    return await axios.delete(EnvService.serviceURLPL+restUrl+"/"+key+"/"+EnvService.dataTargetEnvironment, {
      data: key,
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async updateDataTarget(restUrl, item, key) {
    return await axios.put(EnvService.serviceURLPL+restUrl+"/"+key+"/"+EnvService.dataTargetEnvironment, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async insertDataTarget(restUrl, item) {
    return await axios.post(EnvService.serviceURLPL+restUrl, item, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  //reporting
  async getReport(restUrl, reportData) {
    return await axios.post(EnvService.serviceURLReporting+restUrl+"/"+reportData.name+"/"+reportData.outputType, reportData, {
      auth: {
        username: this.ctx.$store.getters.reportUsername,
        password: this.ctx.$store.getters.reportPassword
      }
    })
  }

  async getReportAsBlob(restUrl, reportData, reportFormat) {
      return await axios.post(EnvService.serviceURLReporting+restUrl+"/"+reportData.name+"/"+reportFormat, reportData, {
      auth: {
        username: this.ctx.$store.getters.reportUsername,
        password: this.ctx.$store.getters.reportPassword
      },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json"
      }
    })    
  }

  //Web log
  async createLogEntry(restUrl, logEntry) {
    return await axios.post(EnvService.serviceURLPL+restUrl, logEntry, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  //Central Logging
  async createMessageLogEntry(restUrl, logEntry) {
    return await axios.post(EnvService.serviceURLPL+restUrl, logEntry)
  }

  async getIp(restUrl) {
    //without EnvService.serviceURLPL is correct!
    return await axios.get(restUrl)
  }

  async getLoggingInfo(restUrl, appId, env) {
    return await axios.get(EnvService.serviceURLPL+restUrl+"/"+appId+"/"+env)
  }

  //Orders
  async getOrders(restUrl,sapClientId,eMail,sprcd) {
    return await axios.get(EnvService.serviceURLPL+restUrl+"/"+sapClientId+"/"+EnvService.dataTargetEnvironment+"/"+eMail+"/"+sprcd, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async getOrder(restUrl,id,sprcd) {
    return await axios.get(EnvService.serviceURLPL+restUrl+"/"+id+"/"+sprcd, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async deleteOrder(restUrl, id) {
    return await axios.delete(EnvService.serviceURLPL+restUrl+"/"+id, {
      data: id,
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

  async createOrder(restUrl, orderEntry) {
    return await axios.post(EnvService.serviceURLPL+restUrl, orderEntry, {
      auth: {
        username: this.ctx.$store.getters.username,
        password: this.ctx.$store.getters.password
      }
    })
  }

}
